// Replicates the auth/init logic from Services.js created() hook.
// Components using composables instead of the Services mixin should
// call useAuth() in their setup to handle authentication.
import { getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useApi, getHttpInstance, setApiConfig } from './useApi';
import { useAppState } from './useAppState';
export function useAuth() {
    const route = useRoute();
    const router = useRouter();
    const api = useApi();
    const state = useAppState();
    const instance = getCurrentInstance();
    const cookies = instance?.appContext.config.globalProperties.$cookies;
    // Set API config from route meta
    const apiUrl = route.meta.api;
    const configUri = route.meta.configUri;
    state.api = apiUrl;
    state.configUri = configUri;
    setApiConfig({
        api: apiUrl,
        configUri: configUri,
        useCache: state.useCache,
        useCachedEndpoints: state.useCachedEndpoints,
        cachedBlacklist: state.cachedBlacklist,
        cookies: cookies,
        router: router,
    });
    // Auth logic
    const authenticated = route.meta.authenticated;
    if (authenticated == undefined || authenticated) {
        if (route.query.u) {
            cookies?.set('user', route.query.u, '1m');
            cookies?.set('pass', route.query.p, '1m');
            api.login(route.query.u, route.query.p);
        }
        else if (cookies?.get('token')) {
            state.token = cookies.get('token');
            getHttpInstance().defaults.headers.common = { "Authorization": "bearer " + state.token };
        }
        else if (cookies?.get('user')) {
            api.login(cookies.get('user'), cookies.get('pass'));
        }
        else if (route.query.t) {
            state.token = route.query.t;
            cookies?.set('token', state.token, '30min');
            getHttpInstance().defaults.headers.common = { "Authorization": "bearer " + state.token };
        }
        else {
            router.push({ path: '/Login', query: { landingpage: route.path } });
        }
    }
    // Set menu state from route meta
    state.menuShown = !!route.meta.bottomMenu;
    state.drawerBottom = route.meta.bottomMenu ? 46 : -23;
}
